import { isString, stringToElements } from '../utils/helpers.js'
import { isAbove } from '../utils/breakpoints'

/**
 * Smooth scrolling
 * @param  {[Element, String]} targetEl
 * @param  {Int} duration
 * @param  {Int} offset
 * @param  {Function} callback
 */
// export function smoothScroll (targetEl, offset = 0, duration = 600, callback = undefined) {
//   if (isString(targetEl)) {
//     targetEl = document.querySelector(targetEl)
//   }

//   if (!targetEl) {
//     return
//   }

//   // Add extra offset for fixed head
//   if (!isAbove('sm')) {
//     offset -= 60
//   }

//   window.scrollTo({
//     behavior: 'smooth',
//     left: 0,
//     top: window.pageYOffset + targetEl.getBoundingClientRect().top + offset
//   })

//   if (callback) {
//     window.setTimeout(() => {
//       callback()
//     }, duration)
//   }
// }

export function popup(text, theme = 'red', callback = null) {
  if (!isString(text)) {
    return
  }

  const existingAlerts = document.querySelectorAll('.Alert')
  const alertID = 'alert_' + existingAlerts
  const alertEl = stringToElements(
    '<div id="' +
      alertID +
      '" class="Alert Alert--' +
      theme +
      '" role="alert"><p>' +
      text +
      '</p><button class="Alert-close js-alertClose" type="button"><svg class="Alert-closeSymbol" role="presentation"><use xlink:href="#symbol-cross"></use></svg></button></div>',
  )

  document.body.appendChild(alertEl)

  if (existingAlerts.length) {
    existingAlerts.forEach((alert) => {
      alertEl.style.bottom = alert.offsetHeight + 'px'
    })
  }

  alertEl.querySelector('.js-alertClose').addEventListener(
    'click',
    () => {
      document.body.removeChild(alertEl)

      if (callback) {
        callback()
      }
    },
    false,
  )
}
